import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const names = {
  unUpdateDataList: ItemName.of([Locale.ja, '未更新データ一覧']),
};

export const unUpdated = {
  names,
};
